import { render, staticRenderFns } from "./ProjectImport.vue?vue&type=template&id=fab6074e&"
import script from "./ProjectImport.vue?vue&type=script&lang=ts&"
export * from "./ProjectImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports